"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GenericCacheTokenHelper {
    static tplGuidToToken = {};
    async getToken(tplGuid) {
        const existingToken = GenericCacheTokenHelper.tplGuidToToken[tplGuid];
        //return existing token if exists and is not expired
        if (existingToken) {
            const payloadBase64 = existingToken.split('.')[1];
            const decodedJson = Buffer.from(payloadBase64, 'base64').toString();
            const decoded = JSON.parse(decodedJson);
            const exp = decoded.exp;
            /**
             * Work around for WMS token expiry bug using server time instead of utc
             * The token expiry is using central time, to validate the token we get utc - 4hours
             */
            const now = Date.now() - 14400000; //60 * 60 * 1000 * 4 = 4 hours
            const expired = now >= exp * 1000;
            if (!expired)
                return existingToken;
        }
        return undefined;
    }
    async updateToken(tplGuid, token) {
        GenericCacheTokenHelper.tplGuidToToken[tplGuid] = token;
    }
}
exports.default = GenericCacheTokenHelper;
